import * as React from 'react';
import classNames from 'classnames';
import Icon from '../../icon';
import { RangePicker as RCRangePicker } from 'rc-picker';
import { GenerateConfig } from 'rc-picker/lib/generate/index';
import enUS from '../locale/en_US';
import { ConfigContext } from 'antd/lib/config-provider/context';
import { ConfigConsumerEProps } from "../../config-provider";
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver';
import { getRangePlaceholder } from '../util';
import PagePoint from "../../page-point";
import { RangePickerProps, PickerLocale, getTimeProps, Components } from '.';


const {
    sendPagePoint,
    pagePointConfig: { regKey },
    EventType: { clickType}
  } = PagePoint;

export default function generateRangePicker<DateType>(
  generateConfig: GenerateConfig<DateType>,
): React.ComponentClass<RangePickerProps<DateType>> {
  class RangePicker extends React.Component<RangePickerProps<DateType> & {[propName: string]: any}> {
    static componentName = 'RangePicker';
    static contextType = ConfigContext as any;

    context: ConfigConsumerEProps;

    origValue: any;

    pickerRef = React.createRef<RCRangePicker<DateType>>();

    focus = () => {
      if (this.pickerRef.current) {
        this.pickerRef.current.focus();
      }
    };

    blur = () => {
      if (this.pickerRef.current) {
        this.pickerRef.current.blur();
      }
    };

    getDefaultLocale = () => {
      const { locale } = this.props;
      const result = {
        ...enUS,
        ...locale,
      };
      result.lang = {
        ...result.lang,
        ...((locale || {}) as PickerLocale).lang,
      };
      return result;
    };

    renderPicker = (locale: PickerLocale) => {
      const { getPrefixCls, getPopupContainer, pagePoint } = this.context;
      const {
        prefixCls: customizePrefixCls,
        getPopupContainer: customGetPopupContainer,
        getCalendarContainer,
        monthCellContentRender,
        monthCellRender:customizeMonthCellRender,
        className,
        size: customizeSize,
        onChange,
        bordered = true,
        placeholder,
        showDateInput,
        inputReadOnly,
        [regKey]: dataRegId,
        ...restProps
      } = this.props;
      const { format, showTime, picker } = this.props as any;
      const prefixCls = getPrefixCls('picker', customizePrefixCls);

      let newChange = onChange;
      if (pagePoint && dataRegId) {
          newChange = (dateMomnet, dateString) => {
            onChange && onChange(dateMomnet, dateString);
            let dateStr:any = dateString;
            // rangepicker为数组
            if (Array.isArray(dateString)) {
              dateStr = JSON.stringify(dateString);
            }
            // change 发送 click
            sendPagePoint({
              eventType: clickType,
              tagname: "datetimePicker",
              value: dateStr,
              [regKey]: dataRegId,
              origValue: this.origValue
            });
            this.origValue = dateStr;
          };
        }

      const inputRO = showDateInput===false ? inputReadOnly || true : inputReadOnly;

      let additionalOverrideProps: any = {};

      additionalOverrideProps = {
        ...additionalOverrideProps,
        ...(showTime ? getTimeProps({ format, picker, ...showTime }) : {}),
        ...(picker === 'time' ? getTimeProps({ format, ...this.props, picker }) : {}),
      };


     const mergedSize = customizeSize;

            return (
              <RCRangePicker<DateType>
                separator={
                  <span aria-label="to" className={`${prefixCls}-separator`}>
                   <Icon type="swap-right" />
                  </span>
                }
                ref={this.pickerRef}
                placeholder={getRangePlaceholder(picker, locale, placeholder)}
                suffixIcon={picker === 'time' ?<Icon type="clock-circle" /> : <Icon type="calendar" />}
                clearIcon={<Icon type="close-circle" />}
                allowClear
               // transitionName="slide-up"
                {...restProps}
                {...additionalOverrideProps}
                className={classNames(className, {
                  [`${prefixCls}-${mergedSize}`]: mergedSize,
                  [`${prefixCls}-borderless`]: !bordered,
                })}
                locale={locale!.lang}
                prefixCls={prefixCls}
                getPopupContainer={customGetPopupContainer || getCalendarContainer || getPopupContainer}
                monthCellRender = {customizeMonthCellRender || monthCellContentRender}
                generateConfig={generateConfig}
                prevIcon={<span className={`${prefixCls}-prev-icon`} />}
                nextIcon={<span className={`${prefixCls}-next-icon`} />}
                superPrevIcon={<span className={`${prefixCls}-super-prev-icon`} />}
                superNextIcon={<span className={`${prefixCls}-super-next-icon`} />}
                components={Components}
                onChange={newChange}
                inputReadOnly={inputRO}
              />
            );
    };

    render() {
      return (
        <LocaleReceiver componentName="DatePicker" defaultLocale={this.getDefaultLocale}>
          {this.renderPicker}
        </LocaleReceiver>
      );
    }
  }

  return RangePicker;
}



// WEBPACK FOOTER //
// ./src/components/date-picker/generatePicker/generateRangePicker.tsx